import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieConsentContext = createContext();

const CONSENT_STORAGE_KEY = 'cookie-consent-preferences';

export const CookieConsentProvider = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(null); // null = not decided yet
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const storedConsent = localStorage.getItem(CONSENT_STORAGE_KEY);
    
    if (storedConsent !== null) {
      setHasConsent(storedConsent === 'true');
      setShowBanner(false);
    } else {
      // No consent stored, show banner
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
    setHasConsent(true);
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'false');
    setHasConsent(false);
    setShowBanner(false);
  };

  const resetConsent = () => {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
    setHasConsent(null);
    setShowBanner(true);
  };

  const openConsentSettings = () => {
    setShowBanner(true);
  };

  const closeConsentSettings = () => {
    if (hasConsent !== null) {
      setShowBanner(false);
    }
  };

  return (
    <CookieConsentContext.Provider
      value={{
        hasConsent,
        showBanner,
        acceptCookies,
        rejectCookies,
        resetConsent,
        openConsentSettings,
        closeConsentSettings,
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }
  return context;
};
